import Vue from 'vue'
import App from './App.vue'
import router from './routers'
import EasySlider from 'vue-easy-slider'
Vue.use(EasySlider)
Vue.config.productionTip = false
// console.log('======',)
new Vue({
	render: h => h(App),
	router
}).$mount('#app')